export const MAX_LIMIT = 3; 

// Environment-based API URL configuration
// Uses REACT_APP_API_BASE_URL from environment variables, with fallback to production
export const BASE_URL = "https://api.webs2pdf.com/"; 